var map = {
	"./Access.svg": "b1a6",
	"./Group 657.svg": "d725",
	"./Mask.svg": "1d67",
	"./airtime-data.svg": "3775",
	"./bell.svg": "8590",
	"./bills.svg": "8b55",
	"./check-grey.svg": "75cf",
	"./check.svg": "4a24",
	"./failed.svg": "1ad9",
	"./fcmb.svg": "2b77",
	"./flags/GH.svg": "2051",
	"./flags/NG.svg": "9456",
	"./flags/USA.svg": "6eb0",
	"./gtb.svg": "0a4c",
	"./load.svg": "928d",
	"./logo.svg": "a5f7",
	"./min-logo.svg": "ede6",
	"./naira-icon.svg": "bd89",
	"./search.svg": "0a17",
	"./telcos/9MOBILE.svg": "2714",
	"./telcos/AIRTEL.svg": "5b71",
	"./telcos/GLO.svg": "39b0",
	"./telcos/MTN.svg": "8bce",
	"./tigo.svg": "608c",
	"./transfer.svg": "02db",
	"./trophy.svg": "5b1c",
	"./vodafone.svg": "a29e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4555";